import axios from 'axios';
import { API_URL, getAuthHeader } from '.';
import { State } from '../Models/State';
import { UserLevel } from '../Models/UserLevel';
import { Industry } from '../Models/Industry';
import { FileType } from '../Models/FileType';
import { ResponseModel } from '../Models/ResponseModel';
import { PageType } from '../Models/PageType';
import { Subscription } from '../Models/Subscription';
import { Tag } from '../Models/Tag';
import { File as ImageFile } from '../Models/File';
import { Manufacturer } from '../Models/Manufacturer';
import { EquipmentSearchData } from '../Models/EquipmentSearchData';
import { CustomOption } from '../Models/CustomOption';
import { Category } from '../Models/Category';
import { SubCategory } from '../Models/SubCategory';
import { CategoryCustom } from '../Models/CategoryCustom';
import { ClientType } from '../Models/ClientType';
import { ClientLocation } from '../Models/ClientLocation';
import { LocationType } from '../Models/LocationType';
import { MarketSegment } from '../Models/MarketSegment';
import { MarketSubSegment } from '../Models/MarketSubSegment';
import { User } from '../Models/User';
import { InventoryType } from '../Models/InventoryType';
import { Frequency } from '../Models/Frequency';
import { AssetStatus } from '../Models/AssetStatus';
import { AssetType } from '../Models/AssetType';
import { Asset } from '../Models/Asset';
import { EquipmentType } from '../Models/EquipmentType';
import { QbreferenceItem } from '../Models/QbreferenceItem';
import { LatestDailyPrice } from '../Models/LatestDailyPrice';
import { LatestDailyPriceRequest } from '../Models/LatestDailyPriceRequest';
import { Country } from '../Models/Country';
import { SendEmailRequest } from '../Models/SendEmailRequest';

class CommonApi {
  static getStates() {
    return axios.get<State[]>(`${API_URL}/api/common/states`, getAuthHeader());
  }
  static getCountries() {
    return axios.get<Country[]>(
      `${API_URL}/api/common/countries`,
      getAuthHeader()
    );
  }
  static getUserLevels() {
    return axios.get<UserLevel[]>(
      `${API_URL}/api/common/userlevels`,
      getAuthHeader()
    );
  }
  static getIndustries() {
    return axios.get<Industry[]>(
      `${API_URL}/api/common/industries`,
      getAuthHeader()
    );
  }
  static getFileTypes() {
    return axios.get<FileType[]>(
      `${API_URL}/api/common/filetypes`,
      getAuthHeader()
    );
  }
  static getSubscriptions() {
    return axios.get<Subscription[]>(
      `${API_URL}/api/common/subscriptions`,
      getAuthHeader()
    );
  }
  static addFile(request: FormData) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/common/addFile`,
      request,
      getAuthHeader()
    );
  }
  static deleteFile(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/common/deleteFile/${id}`,
      getAuthHeader()
    );
  }
  static getPageTypes() {
    return axios.get<PageType[]>(
      `${API_URL}/api/common/pagetypes`,
      getAuthHeader()
    );
  }

  static GetFilesBySitePage(id: number) {
    return axios.get<ImageFile[]>(
      `${API_URL}/api/common/GetFilesBySitePage/${id}`
      // getAuthHeader()
    );
  }
  static getCustomOptions() {
    return axios.get<CustomOption[]>(
      `${API_URL}/api/common/customoptions`,
      getAuthHeader()
    );
  }
  static getExistingEmails() {
    return axios.get<string[]>(`${API_URL}/api/common/existingemails`);
  }
  static getClientTypes() {
    return axios.get<ClientType[]>(`${API_URL}/api/common/clienttypes`);
  }
  static getMarketSegments() {
    return axios.get<MarketSegment[]>(`${API_URL}/api/common/marketsegments`);
  }
  static getMarketSubSegments() {
    return axios.get<MarketSubSegment[]>(
      `${API_URL}/api/common/marketsubsegments`
    );
  }
  static getClientLocations() {
    return axios.get<ClientLocation[]>(`${API_URL}/api/common/locations`);
  }
  static getManufacturers() {
    return axios.get<Manufacturer[]>(`${API_URL}/api/common/manufacturers`);
  }
  static getEquipmentSearchData() {
    return axios.get<EquipmentSearchData>(
      `${API_URL}/api/common/equipmentSearchData`
    );
  }
  static getCategories() {
    return axios.get<Category[]>(`${API_URL}/api/common/categories`);
  }
  static getCategoriesCustom() {
    return axios.get<CategoryCustom[]>(
      `${API_URL}/api/common/categoriescustom`
    );
  }
  static getSubCategories() {
    return axios.get<SubCategory[]>(`${API_URL}/api/common/subcategories`);
  }
  static getLocationTypes() {
    return axios.get<LocationType[]>(`${API_URL}/api/common/locationtypes`);
  }
  static getUsers() {
    return axios.get<User[]>(`${API_URL}/api/common/users`, getAuthHeader());
  }
  static getInventoryTypes() {
    return axios.get<InventoryType[]>(
      `${API_URL}/api/common/inventorytypes`,
      getAuthHeader()
    );
  }
  static getEquipmentTypes() {
    return axios.get<EquipmentType[]>(
      `${API_URL}/api/common/equipmentTypes`,
      getAuthHeader()
    );
  }
  static getFrequencies() {
    return axios.get<Frequency[]>(
      `${API_URL}/api/common/frequencies`,
      getAuthHeader()
    );
  }
  static getAssetStatuses() {
    return axios.get<AssetStatus[]>(
      `${API_URL}/api/common/assetstatuses`,
      getAuthHeader()
    );
  }
  static getAssetTypes() {
    return axios.get<AssetType[]>(
      `${API_URL}/api/common/assettypes`,
      getAuthHeader()
    );
  }
  static getAssets() {
    return axios.get<Asset[]>(`${API_URL}/api/common/assets`, getAuthHeader());
  }
  static getQbreferenceItems() {
    return axios.get<QbreferenceItem[]>(
      `${API_URL}/api/common/qbreferenceitem/noninventory`,
      getAuthHeader()
    );
  }
  static getLatestDailyPrices(request: LatestDailyPriceRequest) {
    return axios.post<LatestDailyPrice>(
      `${API_URL}/api/common/dailyprice`,
      request,
      getAuthHeader()
    );
  }
  static emailReport(request: SendEmailRequest) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/common/email/report`,
      request,
      getAuthHeader()
    );
  }
}

export default CommonApi;
